exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\nhtml, body, #app {\n  height: 100%;\n  margin: 0;\n  padding: 0;\n}\n#app {\n  font-family: PingFangSC, PingFang SC;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  color: #2c3e50;\n}\n", "", {"version":3,"sources":["/src/src/src/App.vue"],"names":[],"mappings":";AAaA;EACA,aAAA;EACA,UAAA;EACA,WAAA;CACA;AAEA;EACA,qCAAA;EACA,oCAAA;EACA,mCAAA;EACA,eAAA;CACA","file":"App.vue","sourcesContent":["<template>\n  <div id=\"app\">\n    <router-view/>\n  </div>\n</template>\n\n<script>\n  export default {\n    name: 'App'\n  }\n</script>\n\n<style>\n  html, body, #app {\n    height: 100%;\n    margin: 0;\n    padding: 0;\n  }\n\n  #app {\n    font-family: PingFangSC, PingFang SC;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    color: #2c3e50;\n  }\n</style>\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7ba5bd90","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = z/+d
// module chunks = 1